import React, { useState } from 'react';

function CalendarLinks({ icsURL, googleCalendarURL, onReset }) {
  const [showImportHint, setShowImportHint] = useState(false);

  const handleDownloadIcs = () => {
    window.location.href = icsURL;
  };

  const handleAddToGoogleCalendar = () => {
    if (!googleCalendarURL) {
      const importTab = window.open(
        'https://calendar.google.com/calendar/u/0/r/settings/export',
        '_blank'
      );
      handleDownloadIcs();
      setShowImportHint(true);
      if (!importTab) {
        alert('Please enable pop-ups, then try again.');
      }
      return;
    }

    const publicFileUrl = new URL(googleCalendarURL);
    const formattedUrl = `${publicFileUrl.host}${publicFileUrl.pathname}${publicFileUrl.search}`;
    const googleImportURL = `https://calendar.google.com/calendar/render?cid=${encodeURIComponent(`webcal://${formattedUrl}`)}`;
    const newTab = window.open('', '_blank');
    if (newTab) {
      newTab.location.href = googleImportURL;
    } else {
      alert("Please enable pop-ups for this site to use this feature.");
    }
  };
  const handleAddToAppleCalendar = () => {
    window.location.href = icsURL;
  };

  return (
    <div className="success-panel">
      <div className="success-message">
        <span className="success-check" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none"><path d="m7 12.5 3.2 3.2L17.5 8.5" /></svg>
        </span>
        <div>
          <h3>Done</h3>
        </div>
      </div>

      <div className="calendar-actions">
        <button className="primary-button" onClick={handleDownloadIcs}>
          Download <span aria-hidden="true">↓</span>
        </button>
        <button className="secondary-button" onClick={handleAddToGoogleCalendar}>
          Add to Google Calendar
        </button>
        <button className="secondary-button" onClick={handleAddToAppleCalendar}>
          Add to Apple Calendar
        </button>
      </div>

      {showImportHint && (
        <p className="import-hint">Select the downloaded .ics file, then click Import.</p>
      )}

      <button className="start-over" onClick={onReset}>Start over</button>
    </div>
  );
}

export default CalendarLinks;
